document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'product-form') return;

    // Change Add to Cart button text
    document.querySelectorAll('product-form').forEach((productForm) => {
      const button = productForm.querySelector('[type="submit"]');
      const buttonText = button?.querySelector('span');

      if (!button || !buttonText) return;

      buttonText.textContent = '✓ Tilføjet';
      button.classList.add('hartli-added');

      setTimeout(() => {
        buttonText.textContent = window.variantStrings?.addToCart || 'Læg i kurv';
        button.classList.remove('hartli-added');
      }, 1500);
    });

    // Gently animate the cart icon
    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (cartIcon) {
      cartIcon.classList.remove('hartli-cart-pulse');

      // Force animation to restart if products are added quickly
      void cartIcon.offsetWidth;

      cartIcon.classList.add('hartli-cart-pulse');

      setTimeout(() => {
        cartIcon.classList.remove('hartli-cart-pulse');
      }, 600);
    }
  });
});